import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { SCENARIO_LIBRARY_DATA } from "../../../utils/dataConstants";
import { DataRow } from "../../../types/common";
import { StyledTableCell, StyledTableContainer } from "./ScenarioCards.Styled";
import { formatNumber } from "../../../utils/helper";

const safeFormatNumber = (value: unknown): string => {
  return typeof value === "number"
    ? formatNumber(value, 1)
    : (value as string) ?? "";
};

interface ScenarioCardTablesProps {
  dataRows: DataRow[];
}

export const ScenarioCardTables: React.FC<ScenarioCardTablesProps> = ({
  dataRows,
}) => {
  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {SCENARIO_LIBRARY_DATA.SCENARIO_TABLE_COLUMNS.map((column) => (
              <StyledTableCell
                key={column.id}
                sx={{
                  background: "#F7F8FB",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'Montserrat',sans-serif",
                    fontWeight: 600,
                    fontSize: "7.26px",
                    lineHeight: "8.85px",
                  }}
                >
                  {column.label}
                </Typography>
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataRows.map((row, index) => (
            <TableRow key={index}>
              {SCENARIO_LIBRARY_DATA.SCENARIO_TABLE_COLUMNS.map((column) => (
                <StyledTableCell
                  key={column.id}
                  sx={{
                    fontFamily: "'Montserrat',sans-serif",
                    fontWeight: 500,
                    fontSize: "7.26px",
                  }}
                >
                  {safeFormatNumber(row[column.id as keyof DataRow])}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default ScenarioCardTables;
